import SvgPanZoom from 'svg-pan-zoom';
import Color from 'color';
import { generateId, throttle, debounce } from '../../utils';

const $win = $(window);

class Floor {
    constructor({ path }) {
        this.$svg = null;
        this.instance = null;

        this._svgPath = path;
        this.SCALE_KOEFF = 0.1;
        this.UPDATE_POPUP_TIMEOUT = 300;
    }

    static transferSvgToCache($svg) {
        if (!$svg || !($svg instanceof $)) return console.log('Нет свг элемента у этого класса');

        if (!Floor.$cachedFloorsDOM) {
            Floor.$cachedFloorsDOM = $('<div id="cached-floors"/>');
            $('body').append(Floor.$cachedFloorsDOM);
            Floor.$cachedFloorsDOM.css({
                'visibility': 'hidden',
                'opacity': 0,
                'height': 0,
                'overflow': 'hidden'
            });
        }

        Floor.$cachedFloorsDOM.append($svg);
    };

    static creteSvg(node) {
        const svgId = `schema-${generateId()}`;
        const $svg = $(node);
        $svg.attr('id', svgId);

        return $svg;
    };

    _loadMap() {
        return new Promise((res, rej) => {
            $.get(this._svgPath, data => {
                if (data && data.children && data.children.length) {
                    res(data.children);
                } else {
                    rej();
                }
            });
        })
    }

    zoomIn() {
        this.instance.zoomIn();
    }

    reset() {
        this.instance.resetZoom();
        this.instance.center();
    }

    zoomOut() {
        this.instance.zoomOut();
    }

    refresh = () => {
        this.instance.resize();
        this.instance.fit();
        this.instance.center();
    };

    getShopsDOM(ids) {
        if (ids.length) {
            const selector = `#${ids.join(', #')}`.replace(/\//g, '\\/');
            return this.$svg.find(selector);
        }
    }

    selectedAreas(ids) {
        if (!Array.isArray(ids)) return;

        this.$svg.find('.is-highlighted').removeClass('is-highlighted');

        const $shops = this.getShopsDOM(ids);
        $shops && $shops.length && $shops.addClass('is-highlighted');
    }

    calculatePosition($item) {
        const { width, height, left: svgX, top: svgY } = $item[0].getBoundingClientRect();

        const shiftY = height / 2;
        const shiftX = width / 2;
        const { left: containerX, top: containerY } = this.$svg.parent()[0].getBoundingClientRect();
        const top = Math.round(svgY - containerY + shiftY);
        const left = +Math.round(svgX - containerX + shiftX);

        return { top, left };
    }

    destroyPopup() {
        if (this._$showedItem && this._$showedItem instanceof $) {
            this._$showedItem.removeClass('is-selected');
            this._$showedItem = null;
        }

        if (this._$popup && this._$popup instanceof $) {
            this._$popup.remove();
            this._$popup = null;
        }
    }

    hidePopup() {
        if (this._$popup && this._$popup instanceof $ && !this._$popup.hasClass('is-hidden')) {
            this._$popup.addClass('is-hidden');
        }
    }

    showPopup = data => {
        const { url = 'https://elitstroymaterials.ru/kovorking/', $item, title, phone = '' } = data;

        if (!$item.length) return;

        const { top, left } = this.calculatePosition($item);
        const fill = getComputedStyle($item[0]).fill;
        const triangleColor = Color(fill).darken(.1).rgb();
        // const shadowColor = Color(fill).darken(.5).alpha(.5).rgb().array().join(', ');

        const css = `
            left: ${left}px;
            top: ${top}px;
            background-color: ${fill};
        `;

        const clearedPhone = phone.replace(/\D/g, '');

        const $html = $(
            `<div class="tooltip js-scheme-tooltip" style="${css}">
              <div class="tooltip__inner">
                ${title && `<a href="${url}" class="tooltip__title js-scheme-tooltip-title">${title}</a>`}
                ${phone && `<a href="tel:${clearedPhone}" class="tooltip__link js-scheme-tooltip-phone">${phone}</a>`}
              </div>
              <div class="tooltip__triangle" style="border-color: ${triangleColor} transparent transparent transparent" />
            </div>`
        );

        this.destroyPopup();

        this._$showedItem = $item;
        this._$showedItem.addClass('is-selected');

        this._$popup = $html;
        this.$svg.after($html);
    };

    changeSizesHandler = () => {
        if (this._$showedItem) {
            setTimeout(() => {
                const { top, left } = this.calculatePosition(this._$showedItem);

                this._$popup.css({
                    top: `${top}px`,
                    left: `${left}px`
                });

                this._$popup.removeClass('is-hidden');
            }, 0);
        }
    };

    _bindHandlers() {
        $win.on('resize', throttle(this.refresh));
    }

    setLogic() {
        const svgId = this.$svg.attr('id');

        this.instance = SvgPanZoom(`#${svgId}`, {
            controlIconsEnabled: false,
            dblClickZoomEnabled: false,
            fit: true,
            center: true,
            zoomScaleSensitivity: this.SCALE_KOEFF,
            minZoom: 0.7,
            maxZoom: 3,
            onUpdatedCTM: this._updateCTMHandler
        });
    }

    _updateCTMHandler = () => {
        this.hidePopup();

        if(!this.__thr) this.__thr = throttle(this.changeSizesHandler, this.UPDATE_POPUP_TIMEOUT);

        this.__thr();
    };

    init(cb) {
        this._loadMap().then(node => {

            this.$svg = Floor.creteSvg(node);
            Floor.transferSvgToCache(this.$svg);
            this._bindHandlers();

            cb(this);
        });
    }
}

export default Floor;




// WEBPACK FOOTER //
// ./components/scheme/floor.js